import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'bank-consent-permissions-dialog',
  templateUrl: './bank-consent-permissions-dialog.component.html',
  styleUrls: ['./bank-consent-permissions-dialog.component.scss'],
  standalone: false,
})
export class BankConsentPermissionsDialogComponent {
  permissions: { name: string }[];

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { permissions: { name: string }[] },
    private dialogRef: MatDialogRef<BankConsentPermissionsDialogComponent>,
  ) {
    this.permissions = data.permissions || [];
  }

  onCloseClicked() {
    this.dialogRef.close();
  }
}